import { agent } from 'src/api/agent';
import { throwApiError } from 'src/api/utils';
import type { TValuesInterpretations } from 'src/store/directories/types';

import type { TDictObject } from './types';

const normalizeFilterData = (data: Record<string, unknown>): Record<string, unknown> => {
  const _data: Record<string, unknown> = {};

  for (const key in data) {
    const value = data[key];

    if (!Array.isArray(value)) {
      _data[key] = value;

      continue;
    }

    _data[key] = value.join(',');
  }

  return _data;
};

export const fetchDirectory = async <T = TDictObject[]>(
  dirName: string,
  options?: {
    filterData?: Record<string, unknown>;
    signal?: AbortSignal;
  },
): Promise<T> => {
  try {
    const normalizedFilterData = options?.filterData ? normalizeFilterData(options.filterData) : {};

    const res = await agent.get<T>(`object/list/${dirName}`, {
      params: {
        DELETED: true,
        ...normalizedFilterData,
      },
      signal: options?.signal,
    });
    return res.data;
  } catch (error) {
    throwApiError(error);
  }
};

export const fetchSettingsLabels = async (): Promise<Record<string, string>> => {
  try {
    const { data: settingsLabels } = await agent.get('settings/labels');

    return settingsLabels;
  } catch (e) {
    throwApiError(e);
  }
};

export const fetchValuesInterpretations = async (): Promise<TValuesInterpretations> => {
  try {
    const { data: valuesInterpretations } = await agent.get('settings/value_interpretations');

    return valuesInterpretations;
  } catch (e) {
    throwApiError(e);
  }
};
